<template>
  <div class="content">
    <template>
      <div class="columns">
        <div class="column">
          <div class="title is-3 has-text-weight-light">
            {{ dashboard.name }}
          </div>
          <div class="subtitle is-6 has-text-weight-bold">
            {{ extended.name }}
          </div>
        </div>
      </div>

      <b-field grouped group-multiline v-if="dashboard.extended.values.length > 1">
        <b-field>
          <b-select
            placeholder="Выберите регион"
            size="is-small"
            icon="map-marker"
            @input="onChangeExtended()"
            v-model="selectedExtended"
            expanded
          >
            <option v-for="extended in dashboard.extended.values" :key="extended.id" :value="extended.id">{{
              extended.name
            }}</option>
          </b-select>
        </b-field>

        <b-field>
          <b-select
            placeholder="Выберите регион сравнения"
            size="is-small"
            icon="map-marker"
            @input="onChangeCompared()"
            v-model="selectedCompared"
            expanded
          >
            <option v-for="compare in dashboard.extended.values" :key="compare.id" :value="compare.id">{{
              compare.name
            }}</option>
          </b-select>
        </b-field>

        <b-field v-if="isCompare">
          <b-button type="is-light" size="is-small" @click="dropCompare()">
            Сброс
          </b-button>
        </b-field>
      </b-field>

      <b-field v-if="mainAxis !== null" grouped group-multiline>
        <b-field v-for="(element, index) in mainAxis" :key="index">
          <b-checkbox
            size="is-small"
            :value="element.default"
            :native-value="element.value"
            @input="toggleMainAxisOption(element.value)"
            >{{ element.name }}</b-checkbox
          >
        </b-field>
      </b-field>

      <b-field grouped group-multiline>

        <b-field v-if="checkNested(dashboard, 'options', 'territory') && dashboard.options.territory.values.length > 1">
          <b-radio-button
            size="is-small"
            v-for="(element, index) in dashboard.options.territory.values"
            :key="index"
            v-model="territoryOption"
            :native-value="element.value"
          >
            <span>{{ element.name }}</span>
          </b-radio-button>
        </b-field>

        <b-field v-if="checkNested(dashboard, 'options', 'ownership') && dashboard.options.ownership.values.length > 1">
          <b-radio-button
            size="is-small"
            v-for="(element, index) in dashboard.options.ownership.values"
            :key="index"
            v-model="ownershipOption"
            :native-value="element.value"
          >
            <span>{{ element.name }}</span>
          </b-radio-button>
        </b-field>

        <b-field v-if="adaptiveScale !== null">
          <b-switch size="is-small" v-model="adaptiveScaleOption">Адаптивная шкала</b-switch>
        </b-field>

        <b-field v-if="showValues !== null">
          <b-switch size="is-small" v-model="showValuesOption">Показать значения</b-switch>
        </b-field>

        <b-field v-if="fullSize !== null">
          <b-switch size="is-small" v-model="fullSizeOption">Переключить вид</b-switch>
        </b-field>

        <b-field v-if="showForecast !== null">
          <b-switch size="is-small" v-model="showForecastOption" disabled
            >Прогноз
            <b-tooltip label="В разработке"> <b-icon icon="information-outline" size="is-small"></b-icon></b-tooltip
          ></b-switch>
        </b-field>
      </b-field>

      <hr />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    this.selectInitialExtended();
  },
  data() {
    return {
      isOpen: true,
      isLoading: true,
      selectedExtended: null,
      selectedCompared: null
    };
  },
  methods: {
    ...mapActions('dashboard', {
      loadExtended: 'loadExtended',
      loadDashboard: 'loadDashboard',
      changeTerritory: 'changeTerritory',
      changeOwnership: 'changeOwnership',
      toggleAdaptiveScale: 'toggleAdaptiveScale',
      toggleShowForecast: 'toggleShowForecast',
      toggleMainAxis: 'toggleMainAxis',
      toggleShowValues: 'toggleShowValues',
      toggleFullSize: 'toggleFullSize'
    }),
    selectInitialExtended() {
      if (this.$route.params.extendedId) {
        this.selectedExtended = this.$route.params.extendedId;
      } else {
        this.selectedExtended = this.getInitialExtendedId();
      }
    },
    getInitialExtendedId() {
      const index = this.dashboard.extended.values.findIndex(el => el.default === true);
      return this.dashboard.extended.values[index].id;
    },
    onChangeExtended() {
      this.$router.push({
        name: 'dashboardExtended',
        params: {
          id: this.$route.params.id,
          extendedId: this.selectedExtended,
          comparedId: this.selectedCompared
        }
      });
    },
    onChangeCompared() {
      this.isLoading = true;
      this.loadExtended({
        id: this.$route.params.id,
        comparedId: this.selectedCompared,
        extendedId: this.$route.params.extendedId || this.getInitialExtendedId()
      }).then(() => {
        this.isLoading = false;
      });
    },
    dropCompare() {
      this.selectedCompared = null;
      this.onChangeCompared();
    },
    toggleMainAxisOption(value) {
      this.toggleMainAxis(value);
    }
  },
  computed: {
    ...mapGetters('dashboard', {
      dashboard: 'dashboard',
      extended: 'extended',
      fullSize: 'fullSize',
      mainAxis: 'mainAxis',
      showForecast: 'showForecast',
      adaptiveScale: 'adaptiveScale',
      showValues: 'showValues',
      territory: 'territory',
      ownership: 'ownership'
    }),
    isCompare() {
      return this.selectedCompared ? true : false;
    },
    showForecastOption: {
      get() {
        return this.showForecast;
      },
      set(value) {
        this.toggleShowForecast(value);
      }
    },
    adaptiveScaleOption: {
      get() {
        return this.adaptiveScale;
      },
      set(value) {
        this.toggleAdaptiveScale(value);
      }
    },
    showValuesOption: {
      get() {
        return this.showValues;
      },
      set(value) {
        this.toggleShowValues(value);
      }
    },
    territoryOption: {
      get() {
        return this.territory;
      },
      set(value) {
        this.changeTerritory(value);
      }
    },
    ownershipOption: {
      get() {
        return this.ownership;
      },
      set(value) {
        this.changeOwnership(value);
      }
    },
    fullSizeOption: {
      get() {
        return this.fullSize;
      },
      set() {
        this.toggleFullSize();
      }
    }
  },
  watch: {
    $route(to, from) {
      this.isLoading = true;
      this.selectedCompared = to.params.id === from.params.id ? this.selectedCompared : null;
      if (to.params.id !== from.params.id) {
        this.loadDashboard(this.$route.params.id)
          .then(() => {
            this.loadExtended({
              id: this.dashboard.id,
              comparedId: this.selectedCompared,
              extendedId: this.$route.params.extendedId || this.getInitialExtendedId()
            });
          })
          .then(() => {
            this.isLoading = false;
            this.selectInitialExtended();
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
          });
      } else {
        this.loadExtended({
          id: this.dashboard.id,
          comparedId: this.selectedCompared,
          extendedId: this.$route.params.extendedId || this.getInitialExtendedId()
        })
          .then(() => {
            this.isLoading = false;
            this.selectInitialExtended();
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  position: relative;
}

.row {
  border-bottom: 1px solid #ddd;
}

[disabled] {
  color: #999;
}

.ml-auto {
  margin-left: auto;
}
</style>
